// Centralized download links configuration
export const DOWNLOAD_LINKS = {
  // Windows download link
  WINDOWS: "https://github.com/therealguillermo/AirMouseReleases/releases/download/1.1/AirMouse-Setup-1.1.exe",
  
  // macOS download link
  MACOS: "https://github.com/therealguillermo/AirMouseReleases/releases/download/1.1DMG/AirMouse-universal.dmg",
  
  // App Store download link
  APP_STORE: "https://apps.apple.com/us/app/air-mouse/id6751875086"
};

// Helper function to get the appropriate download link based on platform
export const getDownloadLink = (platform) => {
  switch (platform) {
    case 'windows':
      return DOWNLOAD_LINKS.WINDOWS;
    case 'macos':
      return DOWNLOAD_LINKS.MACOS;
    default:
      return DOWNLOAD_LINKS.WINDOWS; // fallback to Windows
  }
};

// Platform detection helper
export const detectPlatform = () => {
  const userPlatform = navigator.platform.toLowerCase();
  if (userPlatform.includes('mac')) {
    return 'macos';
  }
  return 'windows';
}; 